/**
 * Wrapper for JournalEntryForm that handles create mutation internally.
 * Used by QuickCreateMenu to create new journal entries.
 */

import { useTranslation } from 'react-i18next';
import { JournalEntryForm } from '../../modules/accounting/components/JournalEntryForm';
import { useCreateJournalEntry } from '../../modules/accounting/hooks/useJournalEntries';
import { useNotification } from '../../shared/context/NotificationContext';
import type { JournalEntryCreate } from '../../modules/accounting/types';

interface QuickCreateJournalEntryFormProps {
  open: boolean;
  onClose: () => void;
}

export function QuickCreateJournalEntryForm({ open, onClose }: QuickCreateJournalEntryFormProps) {
  const { t } = useTranslation('accounting');
  const { showSuccess } = useNotification();
  const createEntry = useCreateJournalEntry();

  const handleSubmit = async (data: JournalEntryCreate) => {
    try {
      await createEntry.mutateAsync(data);
      showSuccess(t('journalEntries.createSuccess'));
      onClose();
    } catch {
      // The global mutation-error handler shows the specific translated toast.
    }
  };

  return (
    <JournalEntryForm
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      entry={null}
      isLoading={createEntry.isPending}
    />
  );
}
